import { multiStyleConfig } from "@chakra-ui/theme-tools";
import checkbox from "./checkbox";
var radio = multiStyleConfig({
  parts: {
    control: "the radio input container",
    label: "the radio label"
  },
  baseStyle: function baseStyle(props) {
    var _checkbox$baseStyle, _checkbox$baseStyle2;

    var _ref = (_checkbox$baseStyle = (_checkbox$baseStyle2 = checkbox.baseStyle) === null || _checkbox$baseStyle2 === void 0 ? void 0 : _checkbox$baseStyle2.call(checkbox, props)) !== null && _checkbox$baseStyle !== void 0 ? _checkbox$baseStyle : {},
        label = _ref.label,
        control = _ref.control;

    return {
      label: label,
      control: Object.assign({}, control, {
        borderRadius: "full",
        _checked: Object.assign({}, control === null || control === void 0 ? void 0 : control["_checked"], {
          _before: {
            content: "\"\"",
            display: "inline-block",
            position: "relative",
            width: "50%",
            height: "50%",
            borderRadius: "50%",
            bg: "currentColor"
          }
        })
      })
    };
  },
  sizes: Object.assign({}, checkbox.sizes, {
    sm: {
      control: {
        width: 3,
        height: 3
      }
    }
  }),
  defaultProps: {
    size: "md",
    colorScheme: "teal"
  }
});
export default radio;